import React, { useContext } from "react";
import { FilterBar } from "@sscs/ui";
import { EndpointFilter, SecretLivenessFilter, ServiceFilter, TriagedSwitch, } from "../../common";
import { ReportContext } from "../../context";
import { useLazyGetSecretsEndpointsQuery, useLazyGetSecretsServicesQuery, } from "../../services/secrets.api";
const SecretsFilters = ({ filter, onFilterChange, }) => {
    var _a, _b;
    const { reportId } = useContext(ReportContext);
    const [fetchServices, { data: servicesData, isFetching: areServicesFetching },] = useLazyGetSecretsServicesQuery();
    const [fetchEndpoints, { data: endpointsData, isFetching: areEndpointsFetching },] = useLazyGetSecretsEndpointsQuery();
    return (React.createElement(FilterBar, { filters: [
            {
                id: "service",
                row: 1,
                minWidth: "225px",
                control: (React.createElement(ServiceFilter, { services: (_a = servicesData === null || servicesData === void 0 ? void 0 : servicesData.services) !== null && _a !== void 0 ? _a : [], loading: areServicesFetching, value: filter.service, onChange: (value) => onFilterChange({
                        secret_liveness: filter.secret_liveness,
                        service: value,
                        endpoint: filter.endpoint,
                        hide_triaged: filter.hide_triaged,
                    }), onOpen: () => fetchServices({ ui_id: reportId }) })),
            },
            {
                id: "endpoint",
                row: 2,
                minWidth: "225px",
                control: (React.createElement(EndpointFilter, { endpoints: (_b = endpointsData === null || endpointsData === void 0 ? void 0 : endpointsData.endpoints) !== null && _b !== void 0 ? _b : [], loading: areEndpointsFetching, value: filter.endpoint, onChange: (value) => onFilterChange({
                        secret_liveness: filter.secret_liveness,
                        service: filter.service,
                        endpoint: value,
                        hide_triaged: filter.hide_triaged,
                    }), onOpen: () => fetchEndpoints({ ui_id: reportId }) })),
            },
            {
                id: "liveness",
                row: 2,
                width: "200px",
                control: (React.createElement(SecretLivenessFilter, { value: filter.secret_liveness, onChange: (value) => onFilterChange({
                        secret_liveness: value,
                        service: filter.service,
                        endpoint: filter.endpoint,
                        hide_triaged: filter.hide_triaged,
                    }) })),
            },
            {
                id: "triaged",
                row: 2,
                fit: true,
                control: (React.createElement(TriagedSwitch, { hideTriaged: filter.hide_triaged, onToggle: (checked) => onFilterChange({ ...filter, hide_triaged: checked }) })),
            },
        ] }));
};
export default SecretsFilters;
//# sourceMappingURL=SecretsFilters.js.map